
import { useEffect } from 'react';

export const useShopData = (shopId?: string) => {
  // Add logging for shopId to debug
  useEffect(() => {
    console.log('useOrderForm - current shopId:', shopId);
  }, [shopId]);
  
  return { shopId };
};
